import { render, staticRenderFns } from "./notification-dashboard.vue?vue&type=template&id=de3d9fc4&scoped=true&"
import script from "./notification-dashboard.vue?vue&type=script&lang=js&"
export * from "./notification-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./notification-dashboard.vue?vue&type=style&index=0&id=de3d9fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3d9fc4",
  null
  
)

export default component.exports